import { render, staticRenderFns } from "./BilletsReports.vue?vue&type=template&id=5af0b0e6&scoped=true&"
import script from "./BilletsReports.vue?vue&type=script&lang=js&"
export * from "./BilletsReports.vue?vue&type=script&lang=js&"
import style0 from "./BilletsReports.vue?vue&type=style&index=0&id=5af0b0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0b0e6",
  null
  
)

export default component.exports